export const devPublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgHN20ftliNIauGDHCYS2
gnWpsVdMP/h/Zlxal/jlKDpjDmuIdOQAlDrj2NPOJcwj1BukkFHEcZaVOSkYJ0+e
TARnS9YqoH1ZQpDhg/urN7x+DLBbstqYs4yTHIgf8MhfHQJKdom5nDYp0Jtsjk4Z
ygFKuE4fwuI/Pc5H+XNmLiQDedwBObYIGarlRBnsj+SAg4IrO9dddRedhcX63FEk
LQSRR9ZiGWtbIHhN6KfSFk0dNEqWAAkzeF8rzHAcoKaZ81/iYLoGlumN79tcpNzd
PJXnQ2vKkm4vwU2EvdRGW8DRDYxJAEtPRTF7w+i3acMm0KN9A9g+z8v0sxr06RsT
vwIDAQAB
-----END PUBLIC KEY-----`

export const proPublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyyievjlLz3wTYgWQW0td
wapEHsPFAoNKo2+iRSUBJBJo/wFet1L18+zTrGUDXNFc3XE8ZjrrQPT4/4SKDxn6
L0XzPWvoJ0tVgiXEbwWhgXNAPPugoiGa9sHPWIQit1Ata0sjHCjDdUjHoP0XhB7J
bu38ffXvDOBXra+UhsX9uB6QhS+uQG5IPJ2tjCBJRu1M7NxjPuVc46onp7OO23HY
x9fa6pDslnBK1/J/33068MN9azwD3Hpu6u4FDxp5Q1i7qoiW8Q21rMgEneXTeHd9
jR0YfR4JTmp9q7ndqNviNdfsnyIypHKFKa+OjNNDpnuNvIwT+FplS/SK79D7n2wn
2wIDAQAB
-----END PUBLIC KEY-----`

export const registerPublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0TwDqRA1pB5HO1H2pqys
zN5yvKj56/5a2rIoL5h9SWydgSjED3M7FAzAvhGUcibahAPWHVoYwqzwPOp6Er4w
ph4hq9P/Enp3wqkdng890vtu6cg5ahsxR2EheTnGB9OR2l+SSPI12qhFoPHyKLZj
BhPSOrCDc5vvOykOpBrJoK2Abd/J5wKewlV1xrKkWmDwrmmAVorZzMdRPoMo80Qb
S3xhrU+68/ew0lUU4b7oUSw7mbF/mIVk0pHNqc55eaetxaHYq0SpIT89pwe7/bKk
mH0/esGJURWSWmAjOIebD47S9f1eB4yY/YDTJex3hiWTO6BhCqYNStH0n05O0pNx
+QIDAQAB
-----END PUBLIC KEY-----`
